var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('Todo',{staticClass:"mt-5"}),_c('TodoList',{staticClass:"mt-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }